import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import {
  AssinaturaService,
  ConsultaAssinatura,
} from "src/app/core/services/assinatura.service";

@Component({
  selector: "app-assinatura-modal",
  templateUrl: "./assinatura-modal.component.html",
  styleUrls: ["./assinatura-modal.component.css"],
})
export class AssinaturaModalComponent implements OnInit, OnDestroy {
  @Input() pedidoId: number;
  @Input() consulta: ConsultaAssinatura | null = null;
  @Output() consultaChange = new EventEmitter<ConsultaAssinatura>();
  @Output() fechar = new EventEmitter<void>();
  @Output() finalizar = new EventEmitter<void>();

  contratoHtml: SafeHtml | null = null;
  mensagem = "";
  carregando = false;
  private polling: ReturnType<typeof setInterval> | null = null;

  constructor(
    private assinaturaService: AssinaturaService,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    if (!this.consulta && this.pedidoId) {
      this.consultar(false);
    }
    const status = this.consulta?.contrato?.status;
    if (status === "ASSINADO" || status === "AUTORIZADO") {
      return;
    }
    this.iniciarPolling();
  }

  ngOnDestroy(): void {
    this.pararPolling();
  }

  get rotulo(): string {
    return AssinaturaService.rotuloStatus(this.consulta?.contrato?.status);
  }

  get podeFinalizar(): boolean {
    return !!this.consulta?.permite_finalizar;
  }

  visualizar() {
    if (!this.pedidoId) return;
    this.mensagem = "";
    this.carregando = true;
    this.assinaturaService.visualizar(this.pedidoId).subscribe({
      next: (html) => {
        this.carregando = false;
        this.contratoHtml = this.sanitizer.bypassSecurityTrustHtml(html);
      },
      error: (error) => {
        this.carregando = false;
        this.mensagem = AssinaturaService.mensagem(error);
      },
    });
  }

  assinar() {
    if (!this.pedidoId) return;
    this.mensagem = "";
    this.carregando = true;
    this.assinaturaService.solicitar(this.pedidoId).subscribe({
      next: (resp) => {
        this.carregando = false;
        this.aplicarSolicitacao(resp.status, resp.url_assinatura);
        if (resp.url_assinatura) {
          window.open(resp.url_assinatura, "_blank", "noopener,noreferrer");
          this.iniciarPolling();
          return;
        }
        this.mensagem =
          "A Autentique não devolveu o link de assinatura. Tente novamente.";
      },
      error: (error) => {
        this.carregando = false;
        if (error?.error?.detail?.codigo === "ASSINATURA_NAO_OBRIGATORIA") {
          const consulta: ConsultaAssinatura = {
            pedido_id: this.consulta?.pedido_id || this.pedidoId,
            contrato_obrigatorio: false,
            contrato: this.consulta?.contrato || null,
            permite_finalizar: true,
          };
          this.atualizarConsulta(consulta);
          this.finalizar.emit();
          return;
        }
        this.mensagem = AssinaturaService.mensagem(error);
      },
    });
  }

  verificar() {
    this.consultar(true);
  }

  baixar() {
    const url = this.consulta?.contrato?.url_documento_assinado;
    if (!url) return;
    window.open(url, "_blank", "noopener,noreferrer");
  }

  fecharModal() {
    this.pararPolling();
    this.fechar.emit();
  }

  finalizarPedido() {
    if (!this.podeFinalizar) return;
    this.pararPolling();
    this.finalizar.emit();
  }

  private consultar(consultarProvedor: boolean) {
    if (!this.pedidoId) return;
    this.assinaturaService.consultar(this.pedidoId, consultarProvedor).subscribe({
      next: (consulta) => this.atualizarConsulta(consulta),
      error: (error) => {
        if (consultarProvedor) {
          this.mensagem = AssinaturaService.mensagem(error);
        }
      },
    });
  }

  private aplicarSolicitacao(status: string, url: string | null) {
    const atual = this.consulta;
    const consulta: ConsultaAssinatura = {
      pedido_id: atual?.pedido_id || this.pedidoId,
      contrato_obrigatorio: atual?.contrato_obrigatorio ?? true,
      permite_finalizar: false,
      contrato: {
        id: atual?.contrato?.id || 0,
        status,
        nome_documento:
          atual?.contrato?.nome_documento || `Contrato do pedido ${this.pedidoId}`,
        url_assinatura: url,
        url_documento_assinado: atual?.contrato?.url_documento_assinado || null,
        assinado_em: null,
        hash_documento: atual?.contrato?.hash_documento || null,
      },
    };
    this.atualizarConsulta(consulta);
  }

  private atualizarConsulta(consulta: ConsultaAssinatura) {
    this.consulta = consulta;
    this.consultaChange.emit(consulta);
    const status = consulta.contrato?.status;
    if (status === "ASSINADO" || status === "AUTORIZADO") {
      this.pararPolling();
    }
  }

  private iniciarPolling() {
    this.pararPolling();
    this.polling = setInterval(() => this.consultar(false), 10000);
  }

  private pararPolling() {
    if (this.polling) {
      clearInterval(this.polling);
      this.polling = null;
    }
  }
}
